// NOTE: hooks
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useAuthContext } from '../../hooks/useAuthContext'
import { toast } from 'sonner'
import { useAuth } from '../../hooks/useAuth'
import { useFormik } from 'formik'
import { SetPwdValidation } from './authValidation'

const useDataSetPwd = () => {
	const { dispatch } = useAuthContext()
	const [urlParams] = useSearchParams()
	const { newPwd } = useAuth()
	const [loadingNewPassword, setLoadingNewPassword] = useState(false)

	const redirect = () => {
		const redirect = urlParams.get('redirect')
		const host = window.location.protocol + '//' + window.location.host
		const search = window.location.search.replace(`redirect=${redirect}`, '')
		window.location.replace(redirect ? host + redirect + search : host + search)
	}

	const handleSetPwd = async (values: any) => {
		if (values.password !== values.confirmPwd) return toast.error("Passwords don't match")
		setLoadingNewPassword(true)

		const response = await newPwd(values.email, urlParams.get('token'), values.password)
		const json = await response.json()

		if (!response.ok) {
			toast.error(json.error)
			setLoadingNewPassword(false)
			return
		}

		// save the user to local storage
		localStorage.setItem('user', JSON.stringify(json))
		dispatch({ type: 'LOGIN', payload: json })
		redirect()
		setLoadingNewPassword(false)
	}

	const { values, errors, touched, handleChange, handleSubmit, handleBlur } = useFormik({
		initialValues: {
			email: urlParams.get('email'),
			password: '',
			confirmPwd: ''
		},
		validationSchema: SetPwdValidation,
		onSubmit: (values, { setSubmitting }) => {
			handleSetPwd(values)
			setSubmitting(false)
		}
	})

	return { loadingNewPassword, values, errors, touched, handleChange, handleSubmit, handleBlur }
}
export default useDataSetPwd
